import { Component } from '@angular/core';
import { MonthSelectorComponent } from './month-selector.component';

@Component({
  selector: 'eid-month-selector-mobile',
  templateUrl: './month-selector-mobile.component.html',
  styleUrls: ['./month-selector-mobile.component.scss']
})
export class MonthSelectorMobileComponent extends MonthSelectorComponent {}
